import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetBusinessCardsRequestSchema,
  TGetBusinessCardsResponseSchema,
} from "./getBusinessCards.schema";

export const getBusinessCards = (axios: IAxiosInstance) => {
  return async (params: TGetBusinessCardsRequestSchema) => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetBusinessCardsResponseSchema>
    >(`/api/business-cards`, { params });

    return response.data;
  };
};
